module.exports = __webpack_public_path__ + "json/market17-0.json?94716875b0e3e33e6ad80d58e299f937";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market17-0.json
// module id = 1260
// module chunks = 3